'Utilities'.page()
'Back'.action({act: 'cancel'})
'Export'.action({spec: "Export.js"})
'Import'.action({spec: "Import.js"})
'Import Unit Costs'.action({spec: "ImportUnitCosts.js"})
'Sync Inventory Levels'.action()
//'Fix General Location Balances'.action()
'Copy WC Regular Prices to RRPs'.action()

'Copy WC Regular Prices to RRPs'.act(async () => {
  let products = await 'products'.bring()
  let updatedCount = 0
  for ( var i = 0; i < products.length; i++ ) {
    let product = products[i]
    let avenue = await product.toMainAvenue(); if ( ! avenue ) continue
    avenue.recommendedRetailPriceIncTax = product._regular_price
    updatedCount++
  }
  let skippedCount = products.length - updatedCount
  await global.foreman.doSave()
  global.gApp.showMessage("Updated " + updatedCount + " of " + products.length + " products. (" + skippedCount + " were skipped as they have no main supplier)")
})

/*
'Fix General Location Balances'.act(async () => {
  let thereAreNonGeneralLocations
  let locs = await 'Location'.bring()
  for ( var i = 0; i < locs.length; i++ ) {
    let loc = locs[i]
    if ( loc.locationName !== 'General' )
      thereAreNonGeneralLocations = true
  }
  if ( thereAreNonGeneralLocations ) {
    global.gApp.showMessage("There are locations other than General - this utility does not apply")
    return
  }
  
  let createGeneralCluster = async (inventory) => {
    let cluster = await inventory.toGeneralCluster()
    cluster.quantityOnHand = inventory.quantityOnHand
    cluster.quantityOnPurchaseOrders = inventory.quantityOnPurchaseOrders 
  }

  let initialiseClusters = async () => {
    let invs = await 'Inventory'.bring()
    for ( var i = 0; i < invs.length; i++ ) {
      let inv = invs[i]
      await createGeneralCluster(inv)
    }
  }

  let deleteClusters = async () => {
    let clusters = await 'Cluster'.bring()
    await clusters.forAllAsync(async cast => {
      await cast.trash({force: true})
    })
  }

  global.foreman.flushCache()
  global.foreman.suspendCastSaves()
  try {
    await deleteClusters()
    await global.foreman.doSave()
    await initialiseClusters()
    await global.foreman.doSave()
  } finally {
    global.foreman.unsuspendCastSaves()
  }
  global.gApp.showMessage("Process Complete")
})
*/

'Sync Inventory Levels'.act(async () => {

  let save = async () => {
    let err = await global.foreman.doSave()
    if ( err )
      throw(new Error(err))
  }

  let recalcInvPOQty = async inv => {
    let product = inv.product
    let lines = await 'POLine'.bring({product: product})
    lines = lines.filter(line => (! line.lineType) || (line.lineType === "Product"))
    let qty = 0
    inv.lastPurchaseDate = global.emptyYMD()
    await lines.forAllAsync(async poLine => {
      let outstanding = (poLine.quantity - poLine.receivedQuantity - poLine.cancelledQuantity)
      if ( (outstanding < 0) && (poLine.quantity > 0) )
        outstanding = 0
      else if ( (outstanding > 0) && (poLine.quantity < 0) )
        outstanding = 0
      qty += outstanding
      let orderDate = await poLine.toOrderDate()
      if ( orderDate > inv.lastPurchaseDate )
        inv.lastPurchaseDate = orderDate
    })
    inv.quantityOnPurchaseOrders = qty
  }

  let recalcQuantitiesOnPurchaseOrders = async () => {
    global.startProgress({message: "Recalculating quantities on purchase orders..."})
    try {
      global.foreman.suspendCastSaves()
      global.foreman.flushCache() // So that all data we get below is up to date
      let invs = await 'Inventory'.bring()
      let done = 0
      await invs.forAllAsync(async inv => {
        await recalcInvPOQty(inv)
        if ( ! inv.situation )
          inv.situation = 'Active'
        done++
        if ( ((done % 100) === 0) || (done === (invs.length - 1)) ) {
          await save()
          await global.updateProgress(done / invs.length)
          await global.wait(100)
        }
      })
    } finally {
      global.foreman.unsuspendCastSaves()
      global.stopProgress()
    }
  }

  let dedupInventory = async (prod) => {
    let inv = await prod.toInventory(); if ( ! inv ) return
    if ( inv._markedForDeletion ) return
    let productId = prod.id; if ( ! productId ) return
    let otherInvs = await 'Inventory'.bring()
    for ( var i = otherInvs.length - 1; i >= 0; i-- ) {
      let otherInv = otherInvs[i]
      let otherProdRef = otherInv.product; if ( ! otherProdRef ) continue
      if ( ! otherProdRef.id ) {
        let otherProd = await 'products'.bringFirst({uniqueName: otherProdRef.keyval})
        if ( ! otherProd )
          continue
        otherProdRef.id = otherProd.id
      }
      if ( otherProdRef.id !== productId ) continue
      if ( otherInv.id === inv.id ) continue
      console.log("Deleting Inventory cast " + otherInv.id + " for product " + prod.uniqueName + "[id: " + prod.id + "] (keeping cast " + inv.id + ")")
      await otherInv.trash()
    }
  }

  let removeDuplicateInventories = async () => {
    global.startProgress({message: "Checking/fixing duplicates..."})
    try {
      global.foreman.suspendCastSaves()
      global.foreman.flushCache() // So that all data we get below is up to date
      let products = await 'products'.bring()
      let done = 0
      await products.forAllAsync(async product => {
        await dedupInventory(product)
        done++
        if ( ((done % 100) === 0) || (done === (products.length - 1)) ) {
          await save()
          await global.updateProgress(done / products.length)
          await global.wait(100)
        }
      })
    } finally {
      global.foreman.unsuspendCastSaves()
      global.stopProgress()
    }
  }

  try {
    await removeDuplicateInventories()
  } catch(e) {
    global.gApp.showMessage("Error removing duplicate inventory records: " + e.message)
    return
  }
  try {
    await recalcQuantitiesOnPurchaseOrders()
  } catch(e) {
    global.gApp.showMessage("Error recalculating quantities on purchase orders: " + e.message)
    return
  }
  try {
    await removeDuplicateInventories() // second round needed for stragglers after PO recalcs
  } catch(e) {
    global.gApp.showMessage("Error removing duplicate inventory records: " + e.message)
    return
  }
  await global.gApp.harmonize({full: true})
})

